module.exports = __webpack_public_path__ + "img/logo.dfe17fd2.png";